// IUB school listings: https://library.iub.edu.bd/gm
// Law uses SL on https://iub.ac.bd/academics/schools/sl and SOL in APA rules.
// Keep both labels; this formatter changes display casing, never school identity.
export const SCHOOL_ABBREVIATIONS = Object.freeze({
    sets: 'SETS',
    sbe: 'SBE',
    sels: 'SELS',
    slass: 'SLASS',
    spph: 'SPPH',
    sl: 'SL',
    sol: 'SOL',
});

export const formatSchoolName = (name) => {
    if (typeof name !== 'string') return '';
    const abbreviation = name.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(SCHOOL_ABBREVIATIONS, abbreviation)
        ? SCHOOL_ABBREVIATIONS[abbreviation]
        : name;
};
